import { push as redirect } from 'connected-react-router';
import React from 'react';
import { useDispatch, connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import VerifySmsFactor from 'components/pages/auth/MfaSms/VerifySmsFactor';
import {
  sendAccountRecoverySMSOTPNotification,
  verifyAccountRecoverySMSOTP,
} from 'redux/actions/accountRecovery.actions';
import {
  sendAccountRecoverySmsOtpNotificationLabel,
  submitAccountRecoverySmsOtpLabel,
} from 'redux/middleware/accountRecovery.middleware';
import { getErrorMessage } from 'redux/selectors/ui.selectors';

const SmsVerify = ({ verifyErrorCode, sendErrorCode }) => {
  const dispatch = useDispatch();
  const routerState = useLocation();
  const recovery = routerState?.state?.recovery;
  const phone = recovery?.obfuscatedPhone;

  if (!phone) {
    dispatch(redirect('/login'));
    return null;
  }

  const handleResend = () => {
    dispatch(sendAccountRecoverySMSOTPNotification());
  };

  const handleSubmitCode = code => {
    dispatch(verifyAccountRecoverySMSOTP({ code }));
  };

  return (
    <VerifySmsFactor
      phoneNumber={phone}
      onSubmit={handleSubmitCode}
      onSendCode={handleResend}
      setIsEditing={() => {}}
      isLoading={false}
      isSending={false}
      smsVerifyError={verifyErrorCode}
      smsOTPSendingError={sendErrorCode}
      canChangeNumber={false}
      status={null}
      showCreateAccountHeader={false}
    />
  );
};

const mapStateToProps = state => {
  return {
    verifyErrorCode: getErrorMessage(state, submitAccountRecoverySmsOtpLabel),
    sendErrorCode: getErrorMessage(
      state,
      sendAccountRecoverySmsOtpNotificationLabel,
    ),
  };
};

export default connect(mapStateToProps)(SmsVerify);
